module.exports = __webpack_public_path__ + "static/img/spec-detail-velcro.769182c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/switcher/spec-detail-velcro.png
// module id = mk9x
// module chunks = 1